// /* eslint-disable no-unused-expressions */
// /* eslint-disable no-sequences */

// import {
//     FaBullhorn,
//     FaUserGraduate,
//     FaCar,
//     FaRegComment,
//     FaMoneyBillWave,
// } from "react-icons/fa";
// // import { IndianRupee } from "lucide-react";
// import {
//     LayoutDashboard,
//     Settings,
//     FileText,
//     BarChart2,
//     Shield,
//     IndianRupee,
//     Cpu,
//     HardDrive,
//     Database,
//     FileClock,
//     Wallet,
//     ClipboardCheck,
//     FileBarChart2,
//     AlertTriangle,
//     User,
//     CheckSquare,
//     MapPin,
//     CornerDownRight,
//     FileCheck,
//     icons,
//     Receipt,
// } from "lucide-react";
// import React, { useState, useEffect, useRef, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { RiLogoutCircleRLine, RiMoneyRupeeCircleFill } from "react-icons/ri";
// import { MdDashboardCustomize } from "react-icons/md";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { FaEllipsisH } from "react-icons/fa";
// import { FaBars, FaTimes } from "react-icons/fa";
// import {
//     ChevronUp,
//     ChevronDown,
//     Building2,
//     GraduationCap,
//     Layers,
//     Clock4,
//     CalendarClock,
//     Users,
//     ClipboardList,
//     CalendarDays,
// } from "lucide-react";
// import { useAuth } from "../Context/MyContext";

// // export const menuItems = [
// //     {
// //         label: "Dashboard",
// //         icon: <LayoutDashboard size={26} />,
// //         dropdown: [
// //             {
// //                 label: "Admin Dashboard",
// //                 route: "/layout/dashboard",
// //                 icon: <LayoutDashboard className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "HR Dashboard",
// //                 route: "/layout/hrdashboard",
// //                 icon: <MdDashboardCustomize className="w-5 h-5" />,
// //             },
// //         ],
// //     },

// //     {
// //         label: "Setup",
// //         icon: <Settings size={26} />,
// //         dropdown: [
// //             // { label: "Add Edit Machine", route: "#", icon: <Cpu className="w-5 h-5" /> },
// //             // { label: "Hardware Setup", route: "#", icon: <HardDrive className="w-5 h-5" /> },
// //             // { label: "Data Process", route: "/layout/dataProcess", icon: <Database className="w-5 h-5" /> },
// //             { label: "Machine Monitor", route: "/layout/monitor" },
// //             { label: "Access Control Monitor", route: "/layout/accessMonitor" },
// //             {
// //                 label: "Log Process",
// //                 route: "/layout/logProcess",
// //                 icon: <FileClock className="w-5 h-5" />,
// //             },
// //         ],
// //     },
// //     {
// //         label: "File",
// //         icon: <FileText size={26} />,
// //         dropdown: [
// //             {
// //                 label: "Company",
// //                 route: "/layout/companybranchtable",
// //                 icon: <Building2 className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Degree",
// //                 route: "/layout/degree",
// //                 icon: <GraduationCap className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Department",
// //                 route: "/layout/departmenttable",
// //                 icon: <Layers className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Office Time Policy",
// //                 route: "/layout/officetimepolicytable",
// //                 icon: <Clock4 className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Shift Details",
// //                 route: "/layout/shiftdetails",
// //                 icon: <CalendarClock className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Employee List",
// //                 route: "/layout/listofallemployee",
// //                 icon: <Users className="w-5 h-5" />,
// //             },
// //             // { label: "Leave Request", route: "/layout/leave", icon: <ClipboardList className="w-5 h-5" /> },
// //             {
// //                 label: "Holiday",
// //                 route: "/layout/Holiday",
// //                 icon: <CalendarDays className="w-5 h-5" />,
// //             },
// //         ],
// //     },
// //     {
// //         label: "Report",
// //         icon: <BarChart2 size={26} />,
// //         dropdown: [
// //             {
// //                 label: "Daily Update",
// //                 route: "/layout/dailyreportcomponent",
// //                 icon: <FileText className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Salary Report",
// //                 route: "/layout/salaryReport",
// //                 icon: <Wallet className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Attendance Logs",
// //                 route: "/layout/attendenceLogs",
// //                 icon: <ClipboardCheck className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Monthly Joining Report",
// //                 route: "/layout/monthlyJoiningReport",
// //                 icon: <FileBarChart2 className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Penalty Report",
// //                 route: "/layout/penaltyReport",
// //                 icon: <AlertTriangle className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Monthly Travel Mis-Punch Report ",
// //                 route: "/layout/monthlyTravelMisPunch",
// //                 icon: <i class="fa-solid fa-car-rear h-5 w-5"></i>,
// //             },
// //             {
// //                 label: "Monthly Machine Mis-Punch Report ",
// //                 route: "/layout/monthlyMachineMisPunch",
// //                 icon: <i class="fa-regular fa-hard-drive h-5 w-5"></i>,
// //             },
// //             {
// //                 label: "Access Control Report ",
// //                 route: "/layout/accessControlReport",
// //                 icon: <i class="fa-solid fa-file-arrow-up h-5 w-5"></i>,
// //             },
// //         ],
// //     },
// //     {
// //         label: "Admin",
// //         icon: <Shield size={26} />,
// //         dropdown: [
// //             // { label: "User Manager", route: "#", icon: <User className="w-5 h-5" /> },
// //             {
// //                 label: "Approve Form",
// //                 route: "/layout/showJoiningData",
// //                 icon: <CheckSquare className="w-5 h-5" />,
// //             },
// //             // { label: "Joining PDF", route: "/layout/JoiningPdf", icon: <FileText className="w-5 h-5" /> },
// //             {
// //                 label: "Joining Form",
// //                 route: "/layout/joiningform",
// //                 icon: <FileCheck className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Employee Register",
// //                 icon: <FaUserGraduate className="w-5 h-5" />,
// //                 route: "/layout/Registrationform",
// //             },
// //             {
// //                 label: "Coordinator Check",
// //                 route: "/layout/coordinatorSupervision",
// //                 icon: <i className="fa-solid fa-users h-5 w-5"></i>,
// //             },
// //         ],
// //     },

// //     {
// //         label: "Travel",
// //         icon: <FaCar size={26} />,
// //         dropdown: [
// //             {
// //                 label: "Travel Requests",
// //                 route: "/layout/travel",
// //                 icon: <MapPin className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Travel Extension Requests",
// //                 route: "/layout/travelExtend",
// //                 icon: <CornerDownRight className="w-5 h-5" />,
// //             },
// //             {
// //                 label: "Restart Sim Track",
// //                 route: "/layout/restart-sim-track",
// //                 icon: <Users className="w-5 h-5" />,
// //             },
// //         ],
// //     },
// //     {
// //         label: "Announcement",
// //         icon: <FaBullhorn size={26} />,
// //         route: "/layout/announcement",
// //     },

// //     /* this code for Assets routes */

// //     {
// //         label: "Assets Mangements",
// //         icon: <i className="fa-xl fa-solid fa-cart-flatbed-suitcase p-4"></i>,
// //         dropdown: [
// //             {
// //                 label: "Asset Master",
// //                 route: "/layout/asset-master",
// //                 icon: null,
// //             },
// //             {
// //                 label: "Asset Assignment",
// //                 route: "/layout/asset-assignment",
// //                 icon: null,
// //             },
// //         ],
// //         // route: "/layout/assetsMangement",
// //     },

// //     /* not working code it will be work on future  */

// //     {
// //         label: "TA /DA Manager",
// //         icon: <RiMoneyRupeeCircleFill size={26} />,
// //         dropdown: [
// //             // { label: "Expense Manager", route: "/layout/cityManager", icon: <Wallet className="w-5 h-5" /> },
// //             {
// //                 label: "Expense TA /DA Request",
// //                 route: "/layout/expenseEase",
// //                 icon: <IndianRupee className="w-5 h-5" strokeWidth={2} />,
// //             },
// //         ],
// //     },
// //     // {
// //     //   label: "Feedback",
// //     //   icon: <FaRegComment size={26} />,
// //     //   route: "/layout/feedback",
// //     // },
// //     // {
// //     //   label: "TA/DA Checker",
// //     //   icon: <ClipboardCheck size={26} />,
// //     //   route: "/layout/taDaChecker",
// //     // },
// // ];

// function Navbar() {
//     const navigate = useNavigate();
//     const [openIndex, setOpenIndex] = useState(null);
//     const [openSideIndex, setOpenSideIndex] = useState(null);
//     const dropdownRef = useRef();
//     // const [visibleCount, setVisibleCount] = useState(menuItems.length);
//     const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//     const [hideLogout, setHidelogOut] = useState(false);

//     const { empData } = useAuth();

//     const isAdmin = empData?.isAdmin;

//     const menuItems = [
//         {
//             label: "Dashboard",
//             icon: <LayoutDashboard size={26} />,
//             dropdown: [
//                 {
//                     label: "Admin Dashboard",
//                     route: "/layout/dashboard",
//                     icon: <LayoutDashboard className="w-5 h-5" />,
//                 },
//                 {
//                     label: "HR Dashboard",
//                     route: "/layout/hrdashboard",
//                     icon: <MdDashboardCustomize className="w-5 h-5" />,
//                 },
//             ],
//         },

//         ...(isAdmin
//             ? [
//                   {
//                       label: "Setup",
//                       icon: <Settings size={26} />,
//                       dropdown: [
//                           // { label: "Add Edit Machine", route: "#", icon: <Cpu className="w-5 h-5" /> },
//                           // { label: "Hardware Setup", route: "#", icon: <HardDrive className="w-5 h-5" /> },
//                           // { label: "Data Process", route: "/layout/dataProcess", icon: <Database className="w-5 h-5" /> },
//                           {
//                               label: "Machine Monitor",
//                               route: "/layout/monitor",
//                           },
//                           {
//                               label: "Access Control Monitor",
//                               route: "/layout/accessMonitor",
//                           },
//                           {
//                               label: "Log Process",
//                               route: "/layout/logProcess",
//                               icon: <FileClock className="w-5 h-5" />,
//                           },
//                       ],
//                   },
//                   {
//                       label: "File",
//                       icon: <FileText size={26} />,
//                       dropdown: [
//                           {
//                               label: "Company",
//                               route: "/layout/companybranchtable",
//                               icon: <Building2 className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Degree",
//                               route: "/layout/degree",
//                               icon: <GraduationCap className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Department",
//                               route: "/layout/departmenttable",
//                               icon: <Layers className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Office Time Policy",
//                               route: "/layout/officetimepolicytable",
//                               icon: <Clock4 className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Shift Details",
//                               route: "/layout/shiftdetails",
//                               icon: <CalendarClock className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Employee List",
//                               route: "/layout/listofallemployee",
//                               icon: <Users className="w-5 h-5" />,
//                           },
//                           // { label: "Leave Request", route: "/layout/leave", icon: <ClipboardList className="w-5 h-5" /> },
//                           {
//                               label: "Holiday",
//                               route: "/layout/Holiday",
//                               icon: <CalendarDays className="w-5 h-5" />,
//                           },
//                       ],
//                   },
//                   {
//                       label: "Report",
//                       icon: <BarChart2 size={26} />,
//                       dropdown: [
//                           {
//                               label: "Daily Update",
//                               route: "/layout/dailyreportcomponent",
//                               icon: <FileText className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Salary Report",
//                               route: "/layout/salaryReport",
//                               icon: <Wallet className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Attendance Logs",
//                               route: "/layout/attendenceLogs",
//                               icon: <ClipboardCheck className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Monthly Joining Report",
//                               route: "/layout/monthlyJoiningReport",
//                               icon: <FileBarChart2 className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Penalty Report",
//                               route: "/layout/penaltyReport",
//                               icon: <AlertTriangle className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Monthly Travel Mis-Punch Report ",
//                               route: "/layout/monthlyTravelMisPunch",
//                               icon: (
//                                   <i class="fa-solid fa-car-rear h-5 w-5"></i>
//                               ),
//                           },
//                           {
//                               label: "Monthly Machine Mis-Punch Report ",
//                               route: "/layout/monthlyMachineMisPunch",
//                               icon: (
//                                   <i class="fa-regular fa-hard-drive h-5 w-5"></i>
//                               ),
//                           },
//                           {
//                               label: "Access Control Report ",
//                               route: "/layout/accessControlReport",
//                               icon: (
//                                   <i class="fa-solid fa-file-arrow-up h-5 w-5"></i>
//                               ),
//                           },
//                       ],
//                   },
//                   {
//                       label: "Admin",
//                       icon: <Shield size={26} />,
//                       dropdown: [
//                           // { label: "User Manager", route: "#", icon: <User className="w-5 h-5" /> },
//                           {
//                               label: "Approve Form",
//                               route: "/layout/showJoiningData",
//                               icon: <CheckSquare className="w-5 h-5" />,
//                           },
//                           // { label: "Joining PDF", route: "/layout/JoiningPdf", icon: <FileText className="w-5 h-5" /> },
//                           {
//                               label: "Joining Form",
//                               route: "/layout/joiningform",
//                               icon: <FileCheck className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Employee Register",
//                               icon: <FaUserGraduate className="w-5 h-5" />,
//                               route: "/layout/Registrationform",
//                           },
//                           {
//                               label: "Coordinator Check",
//                               route: "/layout/coordinatorSupervision",
//                               icon: (
//                                   <i className="fa-solid fa-users h-5 w-5"></i>
//                               ),
//                           },
//                       ],
//                   },

//                   {
//                       label: "Travel",
//                       icon: <FaCar size={26} />,
//                       dropdown: [
//                           {
//                               label: "Travel Requests",
//                               route: "/layout/travel",
//                               icon: <MapPin className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Travel Extension Requests",
//                               route: "/layout/travelExtend",
//                               icon: <CornerDownRight className="w-5 h-5" />,
//                           },
//                           {
//                               label: "Restart Sim Track",
//                               route: "/layout/restart-sim-track",
//                               icon: <Users className="w-5 h-5" />,
//                           },
//                       ],
//                   },
//                   {
//                       label: "Announcement",
//                       icon: <FaBullhorn size={26} />,
//                       route: "/layout/announcement",
//                   },

//                   /* this code for Assets routes */

//                   {
//                       label: "Assets Mangements",
//                       icon: (
//                           <i className="fa-xl fa-solid fa-cart-flatbed-suitcase p-4"></i>
//                       ),
//                       dropdown: [
//                           {
//                               label: "Asset Master",
//                               route: "/layout/asset-master",
//                               icon: null,
//                           },
//                           {
//                               label: "Asset Assignment",
//                               route: "/layout/asset-assignment",
//                               icon: null,
//                           },
//                       ],
//                       // route: "/layout/assetsMangement",
//                   },

//                   /* not working code it will be work on future  */

//                   {
//                       label: "TA /DA Manager",
//                       icon: <RiMoneyRupeeCircleFill size={26} />,
//                       dropdown: [
//                           // { label: "Expense Manager", route: "/layout/cityManager", icon: <Wallet className="w-5 h-5" /> },
//                           {
//                               label: "Expense TA /DA Request",
//                               route: "/layout/expenseEase",
//                               icon: (
//                                   <IndianRupee
//                                       className="w-5 h-5"
//                                       strokeWidth={2}
//                                   />
//                               ),
//                           },
//                       ],
//                   },
//               ]
//             : []),
//     ];

//     const [visibleCount, setVisibleCount] = useState(menuItems.length);

//     // Close dropdown on outside click
//     useEffect(() => {
//         const handler = (e) => {
//             if (
//                 dropdownRef.current &&
//                 !dropdownRef.current.contains(e.target)
//             ) {
//                 setOpenIndex(null);
//             }
//         };
//         document.addEventListener("mousedown", handler);
//         return () => document.removeEventListener("mousedown", handler);
//     }, []);

//     const handleLogout = async () => {
//         try {
//             const res = await axios.get(
//                 `${process.env.REACT_APP_SERVER_ADDRESS}/auth/logout`,
//                 {
//                     withCredentials: true,
//                 },
//             );

//             if (res.data.success) {
//                 toast.error("Logout Successful!", {
//                     position: "top-right",
//                     autoClose: 500,
//                 });
//                 localStorage.removeItem("token");
//                 navigate("/");
//             }
//         } catch (err) {
//             console.error("Logout Error", err);
//             toast.error("Error during logout");
//         } finally {
//             setIsSidebarOpen(false);
//         }
//     };

//     useEffect(() => {
//         const handleResize = () => {
//             const width = window.innerWidth;
//             if (width >= 1280)
//                 setVisibleCount(menuItems.length, setHidelogOut(false)); // full screen
//             // else if (width >= 1280) setVisibleCount(11), setHidelogOut(true);
//             else if (width >= 1024) (setVisibleCount(9), setHidelogOut(true));
//             else if (width >= 768) (setVisibleCount(7), setHidelogOut(true));
//             // eslint-disable-next-line no-unused-expressions
//             else if (width >= 640) (setVisibleCount(5), setHidelogOut(true));
//             else setVisibleCount(3); // very small screens
//         };

//         handleResize(); // initialize
//         window.addEventListener("resize", handleResize);

//         return () => window.removeEventListener("resize", handleResize);
//     }, [menuItems.length]);

//     const visibleItems = menuItems.slice(0, visibleCount);
//     const hiddenItems = menuItems.slice(visibleCount);

//     // Close dropdown when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (
//                 dropdownRef.current &&
//                 !dropdownRef.current.contains(event.target)
//             ) {
//                 setOpenIndex(null);
//                 setIsSidebarOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () =>
//             document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     return (
//         <div className="shadow-md " ref={dropdownRef}>
//             <nav className="bgMainColor py-2">
//                 <div className="ml-5 flex flex-wrap justify-start gap-8 items-center">
//                     {visibleItems.map((item, index) => (
//                         // console.log("topbar : ",item),
//                         <div
//                             key={index}
//                             className="relative flex flex-col items-center"
//                         >
//                             {item.dropdown ? (
//                                 <>
//                                     <button
//                                         onMouseEnter={() => setOpenIndex(index)}
//                                         className="flex justify-center items-center w-full h-full "
//                                     >
//                                         {item.icon}
//                                     </button>

//                                     <span className="text-white text-sm">
//                                         {item.label}
//                                     </span>

//                                     {openIndex === index && (
//                                         <ul className="absolute top-full mt-1 bg-gray-200 text-black shadow-lg rounded-lg z-10 ml-14 border border-gray-200 ">
//                                             {item.dropdown.map((opt, i) => (
//                                                 <li
//                                                     key={i}
//                                                     className="hover:bg-gray-200 rounded-lg   border-b border-gray-400 py-1 px-3 text-md whitespace-nowrap"
//                                                 >
//                                                     <Link
//                                                         to={opt.route}
//                                                         onClick={() =>
//                                                             setOpenIndex(null)
//                                                         }
//                                                     >
//                                                         {opt.label}
//                                                     </Link>
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     )}
//                                 </>
//                             ) : (
//                                 <Link
//                                     to={item.route}
//                                     onClick={() => setOpenIndex(null)}
//                                 >
//                                     <span className="flex justify-center items-center w-full h-full">
//                                         {item.icon}
//                                     </span>
//                                     <span className="text-white text-sm">
//                                         {item.label}
//                                     </span>
//                                 </Link>
//                             )}
//                         </div>
//                     ))}

//                     {hiddenItems.length > 0 && (
//                         <div className="ml-auto mr-5 flex flex-col items-center cursor-pointer sm:flex">
//                             <button
//                                 onClick={() => setIsSidebarOpen(true)}
//                                 className="text-white text-2xl"
//                             >
//                                 <FaBars />
//                             </button>
//                             <span className="text-white text-sm">Menu</span>

//                             {isSidebarOpen && (
//                                 <div className="fixed top-0 right-0 w-64 h-full bg-[#8B5DFF] z-50 flex flex-col">
//                                     {/* Close button */}
//                                     <div className="flex justify-end p-4">
//                                         <button
//                                             onClick={() =>
//                                                 setIsSidebarOpen(false)
//                                             }
//                                             className="text-white text-2xl  "
//                                         >
//                                             <FaTimes />
//                                         </button>
//                                     </div>

//                                     {/* {console.log("open ",openSideIndex)} */}

//                                     {/* Hidden menu items */}
//                                     <div className="flex flex-col gap-2 px-4">
//                                         {hiddenItems.map((item, idx) => (
//                                             // console.log("item", item),
//                                             <div
//                                                 key={idx}
//                                                 className=" group flex flex-col pt-3 "
//                                             >
//                                                 {item.dropdown ? (
//                                                     <div className="">
//                                                         <span
//                                                             className=" pl-2 flex items-center gap-1  "
//                                                             onClick={() =>
//                                                                 setOpenSideIndex(
//                                                                     openSideIndex ===
//                                                                         idx
//                                                                         ? null
//                                                                         : idx,
//                                                                 )
//                                                             }
//                                                         >
//                                                             <span className="text-[14px] flex items-center justify-center text-gray-300">
//                                                                 {item.icon}
//                                                             </span>
//                                                             <span className=" font-semibold py-1 text-gray-300  ">
//                                                                 {item.label}
//                                                             </span>
//                                                             {openSideIndex ===
//                                                             idx ? (
//                                                                 <span className="text-gray-300  ">
//                                                                     <ChevronUp
//                                                                         size={
//                                                                             26
//                                                                         }
//                                                                     />
//                                                                 </span>
//                                                             ) : (
//                                                                 <span className="text-gray-300">
//                                                                     <ChevronDown
//                                                                         size={
//                                                                             26
//                                                                         }
//                                                                     />
//                                                                 </span>
//                                                             )}
//                                                         </span>
//                                                         <div
//                                                             className={`transition-all duration-500 ease-in-out overflow-hidden hover:text-black ${
//                                                                 openSideIndex ===
//                                                                 idx
//                                                                     ? "max-h-auto opacity-100"
//                                                                     : "max-h-0 opacity-0"
//                                                             }`}
//                                                         >
//                                                             {openSideIndex ===
//                                                                 idx && (
//                                                                 <ul className="flex flex-col px-4 py-2 ">
//                                                                     {item.dropdown.map(
//                                                                         (
//                                                                             opt,
//                                                                             i,
//                                                                         ) => (
//                                                                             // console.log(opt),

//                                                                             <li
//                                                                                 key={
//                                                                                     i
//                                                                                 }
//                                                                                 className=" text-sm transition-all duration-200 ease-in-out overflow-hidden    py-1 hover:text-black rounded-md "
//                                                                             >
//                                                                                 <Link
//                                                                                     to={
//                                                                                         opt.route
//                                                                                     }
//                                                                                     // className={`group/${i}`}
//                                                                                     className={`text-black hover:scale-105 `}
//                                                                                     onClick={() => (
//                                                                                         setOpenSideIndex(
//                                                                                             null,
//                                                                                         ),
//                                                                                         setIsSidebarOpen(
//                                                                                             false,
//                                                                                         )
//                                                                                     )}
//                                                                                 >
//                                                                                     {/* {console.log(openIndex)} */}
//                                                                                     {/* <span>{opt?.icon}{opt.label}</span> */}
//                                                                                     <span
//                                                                                         className={`pl-3 py-2 flex items-center gap-1 hover:bg-gray-300 text-gray-300  hover:text-black rounded-md `}
//                                                                                     >
//                                                                                         {
//                                                                                             opt.icon
//                                                                                         }
//                                                                                         {
//                                                                                             opt.label
//                                                                                         }
//                                                                                     </span>
//                                                                                 </Link>
//                                                                             </li>
//                                                                         ),
//                                                                     )}
//                                                                 </ul>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 ) : (
//                                                     <Link
//                                                         to={item.route}
//                                                         onClick={() => (
//                                                             setOpenSideIndex(
//                                                                 null,
//                                                             ),
//                                                             setIsSidebarOpen(
//                                                                 false,
//                                                             )
//                                                         )}
//                                                         className=" text-sm pl-2 font-bold group  text-black border-1 border-black rounded-md"
//                                                     >
//                                                         <span className="flex items-center gap-1 px-1 py-2  rounded-md group-hover:bg-gray-300  ">
//                                                             <span className="text-[14px] flex items-center justify-center group-hover:text-black  text-white">
//                                                                 {item.icon}
//                                                             </span>
//                                                             <span className="text-sm group-hover:text-black text-gray-300 ">
//                                                                 {item.label}
//                                                             </span>
//                                                         </span>
//                                                     </Link>
//                                                 )}
//                                             </div>
//                                         ))}
//                                         <button
//                                             onClick={() => {
//                                                 handleLogout();
//                                             }}
//                                             className="mt-auto mb-4 py-2 px-3 bg-red-600 hover:bg-red-700 text-white rounded-md flex items-center justify-center gap-2"
//                                         >
//                                             <RiLogoutCircleRLine size={20} />
//                                             Logout
//                                         </button>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                     {
//                         // console.log(hideLogout)
//                         hideLogout === false && (
//                             <div
//                                 className="ml-auto mr-4 text-white cursor-pointer"
//                                 onClick={handleLogout}
//                             >
//                                 <RiLogoutCircleRLine size={28} />
//                             </div>
//                         )
//                     }
//                 </div>
//             </nav>
//         </div>
//     );
// }

// export default Navbar;

/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */

import {
    FaBullhorn,
    FaUserGraduate,
    FaCar,
    FaRegComment,
    FaMoneyBillWave,
} from "react-icons/fa";
// import { IndianRupee } from "lucide-react";
import {
    LayoutDashboard,
    Settings,
    FileText,
    BarChart3,
    Shield,
    IndianRupee,
    Cpu,
    HardDrive,
    Database,
    FileClock,
    Wallet,
    ClipboardCheck,
    FileBarChart2,
    AlertTriangle,
    User,
    CheckSquare,
    MapPin,
    CornerDownRight,
    FileCheck,
    Receipt,
    Folder,
    Package,
    Megaphone,
    Building2,
    GraduationCap,
    Layers,
    Clock4,
    CalendarClock,
    Users,
    ClipboardList,
    CalendarDays,
    Car,
    ChevronUp,
    ChevronDown,
    MessagesSquare,
    LifeBuoy,
    MessageSquareText,
   LocateFixed
} from "lucide-react";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RiLogoutCircleRLine, RiMoneyRupeeCircleFill } from "react-icons/ri";
import { MdDashboardCustomize } from "react-icons/md";
import { toast } from "react-toastify";
import axios from "axios";
import { FaEllipsisH } from "react-icons/fa";
import { FaBars, FaTimes } from "react-icons/fa";
import { useAuth } from "../Context/MyContext"; // <-- added

function Navbar() {
    const navigate = useNavigate();
    const { empData } = useAuth(); // <-- get user data
    const isAdmin = empData?.isAdmin;

    // Build menuItems dynamically based on isAdmin
    const menuItems = [
        ...(isAdmin
            ? [
                  {
                      label: "Dashboard",
                      icon: <LayoutDashboard size={22} />,
                      dropdown: [
                          {
                              label: "Admin Dashboard",
                              route: "/layout/dashboard",
                              icon: <LayoutDashboard className="w-4 h-4" />,
                          },
                          {
                              label: "HR Dashboard",
                              route: "/layout/hrdashboard",
                              icon: (
                                  <MdDashboardCustomize className="w-4 h-4" />
                              ),
                          },
                      ],
                  },
                  {
                      label: "Setup",
                      icon: <Settings size={22} />,
                      dropdown: [
                          // { label: "Add Edit Machine", route: "#", icon: <Cpu className="w-5 h-5" /> },
                          // { label: "Hardware Setup", route: "#", icon: <HardDrive className="w-5 h-5" /> },
                          // { label: "Data Process", route: "/layout/dataProcess", icon: <Database className="w-5 h-5" /> },
                          {
                              label: "Machine Monitor",
                              route: "/layout/monitor",
                          },
                          {
                              label: "Access Control Monitor",
                              route: "/layout/accessMonitor",
                          },
                          {
                              label: "Log Process",
                              route: "/layout/logProcess",
                              icon: <FileClock className="w-4 h-4" />,
                          },
                      ],
                  },
                  {
                      label: "File",
                      icon: <Folder size={22} />,
                      dropdown: [
                          {
                              label: "Company",
                              route: "/layout/companybranchtable",
                              icon: <Building2 className="w-4 h-4" />,
                          },
                          {
                              label: "Degree",
                              route: "/layout/degree",
                              icon: <GraduationCap className="w-4 h-4" />,
                          },
                          {
                              label: "Department",
                              route: "/layout/departmenttable",
                              icon: <Layers className="w-4 h-4" />,
                          },
                          {
                              label: "Office Time Policy",
                              route: "/layout/officetimepolicytable",
                              icon: <Clock4 className="w-4 h-4" />,
                          },
                          {
                              label: "Shift Details",
                              route: "/layout/shiftdetails",
                              icon: <CalendarClock className="w-4 h-4" />,
                          },
                          {
                              label: "Base Location",
                              route: "/layout/baselocation",
                              icon: <LocateFixed className="w-4 h-4" />,
                          },
                          {
                              label: "Employee List",
                              route: "/layout/listofallemployee",
                              icon: <Users className="w-4 h-4" />,
                          },
                          // { label: "Leave Request", route: "/layout/leave", icon: <ClipboardList className="w-5 h-5" /> },
                          {
                              label: "Holiday",
                              route: "/layout/Holiday",
                              icon: <CalendarDays className="w-4 h-4" />,
                          },
                      ],
                  },
                  {
                      label: "Report",
                      icon: <BarChart3 size={22} />,
                      dropdown: [
                          {
                              label: "Daily Update",
                              route: "/layout/dailyreportcomponent",
                              icon: <FileText className="w-4 h-4" />,
                          },
                          {
                              label: "Salary Report",
                              route: "/layout/salaryReport",
                              icon: <Wallet className="w-4 h-4" />,
                          },
                          {
                              label: "Attendance Logs",
                              route: "/layout/attendenceLogs",
                              icon: <ClipboardCheck className="w-4 h-4" />,
                          },
                          {
                              label: "Monthly Joining Report",
                              route: "/layout/monthlyJoiningReport",
                              icon: <FileBarChart2 className="w-4 h-4" />,
                          },
                          {
                              label: "Penalty Report",
                              route: "/layout/penaltyReport",
                              icon: <AlertTriangle className="w-4 h-4" />,
                          },
                          {
                              label: "Monthly Travel Mis-Punch Report ",
                              route: "/layout/monthlyTravelMisPunch",
                              icon: (
                                  <i className="fa-solid fa-car-rear h-4 w-4"></i>
                              ),
                          },
                          {
                              label: "Monthly Machine Mis-Punch Report ",
                              route: "/layout/monthlyMachineMisPunch",
                              icon: (
                                  <i className="fa-regular fa-hard-drive h-4 w-4"></i>
                              ),
                          },
                          {
                              label: "Access Control Report ",
                              route: "/layout/accessControlReport",
                              icon: (
                                  <i className="fa-solid fa-file-arrow-up h-4 w-4"></i>
                              ),
                          },
                      ],
                  },
                  {
                      label: "Admin",
                      icon: <Shield size={22} />,
                      dropdown: [
                          // { label: "User Manager", route: "#", icon: <User className="w-5 h-5" /> },
                          {
                              label: "Approve Form",
                              route: "/layout/showJoiningData",
                              icon: <CheckSquare className="w-4 h-4" />,
                          },
                          // { label: "Joining PDF", route: "/layout/JoiningPdf", icon: <FileText className="w-5 h-5" /> },
                          {
                              label: "Joining Form",
                              route: "/layout/joiningform",
                              icon: <FileCheck className="w-4 h-4" />,
                          },
                          {
                              label: "Employee Register",
                              icon: <FaUserGraduate className="w-4 h-4" />,
                              route: "/layout/Registrationform",
                          },
                          {
                              label: "Coordinator Check",
                              route: "/layout/coordinatorSupervision",
                              icon: (
                                  <i className="fa-solid fa-users h-4 w-4"></i>
                              ),
                          },
                      ],
                  },
                  {
                      label: "Travel",
                      icon: <Car size={22} />,
                      dropdown: [
                          {
                              label: "Travel Requests",
                              route: "/layout/travel",
                              icon: <MapPin className="w-4 h-4" />,
                          },
                          {
                              label: "Travel Extension Requests",
                              route: "/layout/travelExtend",
                              icon: <CornerDownRight className="w-4 h-4" />,
                          },
                          {
                              label: "Restart Sim Track",
                              route: "/layout/restart-sim-track",
                              icon: <Users className="w-4 h-4" />,
                          },
                      ],
                  },
                  {
                      label: "Announcement",
                      icon: <Megaphone size={22} />,
                      route: "/layout/announcement",
                  },
                  /* Assets */
                  {
                      label: "Assets Mangements",
                      icon: <Package size={22} />,
                      dropdown: [
                          {
                              label: "Asset Master",
                              route: "/layout/asset-master",
                              icon: null,
                          },
                          {
                              label: "Asset Assignment",
                              route: "/layout/asset-assignment",
                              icon: null,
                          },
                      ],
                  },
                  /* TA/DA */
                  {
                      label: "TA /DA Manager",
                      icon: <Receipt size={22} />,
                      dropdown: [
                          {
                              label: "Expense TA /DA Request",
                              route: "/layout/expenseEase",
                              icon: (
                                  <IndianRupee
                                      className="w-4 h-4"
                                      strokeWidth={2}
                                  />
                              ),
                          },
                      ],
                  },

                  // showing the issue  to hr
                  {
                      label: "Write To HR",
                      icon: <MessagesSquare size={22} />,

                      dropdown: [
                          {
                              label: "Show Employe Issue",
                              route: "/layout/write-to-hr",
                              icon: (
                                  <MessageSquareText
                                      className="w-4 h-4"
                                      strokeWidth={2}
                                  />
                              ),
                          },
                          {
                              label: "Show added Issue",
                              route: "/layout/show-issue",
                              icon: (
                                  <ClipboardList
                                      className="w-4 h-4"
                                      strokeWidth={2}
                                  />
                              ),
                          },
                      ],
                  },
              ]
            : []),
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const [openSideIndex, setOpenSideIndex] = useState(null);
    const dropdownRef = useRef();
    const sidebarRef = useRef();
    const [visibleCount, setVisibleCount] = useState(menuItems.length);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [hideLogout, setHideLogout] = useState(false);

    // Handle responsive visibility
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width >= 1280) {
                setVisibleCount(menuItems.length);
                setHideLogout(false);
            } else if (width >= 1024) {
                setVisibleCount(9);
                setHideLogout(true);
            } else if (width >= 768) {
                setVisibleCount(7);
                setHideLogout(true);
            } else if (width >= 640) {
                setVisibleCount(5);
                setHideLogout(true);
            } else {
                setVisibleCount(3);
                setHideLogout(true);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [menuItems.length]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setOpenIndex(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Close sidebar when clicking outside (except on the toggle button)
    useEffect(() => {
        const handleClickOutsideSidebar = (event) => {
            if (
                isSidebarOpen &&
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                !event.target.closest(".sidebar-toggle")
            ) {
                setIsSidebarOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutsideSidebar);
        return () =>
            document.removeEventListener(
                "mousedown",
                handleClickOutsideSidebar,
            );
    }, [isSidebarOpen]);

    // Lock body scroll when sidebar is open
    useEffect(() => {
        if (isSidebarOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isSidebarOpen]);

    // Close sidebar on ESC key
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape" && isSidebarOpen) {
                setIsSidebarOpen(false);
            }
        };
        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [isSidebarOpen]);

    const handleLogout = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_SERVER_ADDRESS}/auth/logout`,
                {
                    withCredentials: true,
                },
            );
            if (res.data.success) {
                toast.error("Logout Successful!", {
                    position: "top-right",
                    autoClose: 500,
                });
                localStorage.removeItem("token");
                navigate("/");
            }
        } catch (err) {
            console.error("Logout Error", err);
            toast.error("Error during logout");
        } finally {
            setIsSidebarOpen(false);
        }
    };

    const visibleItems = menuItems.slice(0, visibleCount);
    const hiddenItems = menuItems.slice(visibleCount);

    // Close open dropdown when sidebar opens
    useEffect(() => {
        if (isSidebarOpen) {
            setOpenIndex(null);
        }
    }, [isSidebarOpen]);

    return (
        <div
            className="relative z-40 bg-slate-900 border-b border-slate-700/50 shadow-lg"
            ref={dropdownRef}
        >
            <nav className="bg-slate-900/95 backdrop-blur-sm">
                <div className="container mx-auto px-4 py-3">
                    <div className="flex flex-wrap items-center justify-start gap-5 lg:gap-7">
                        {visibleItems.map((item, index) => (
                            <div
                                key={index}
                                className="relative flex flex-col items-center group"
                            >
                                {item.dropdown ? (
                                    <>
                                        <button
                                            onMouseEnter={() =>
                                                setOpenIndex(index)
                                            }
                                            className="flex flex-col items-center gap-1.5 transition-all duration-200 text-slate-300 hover:text-[#FDC700] focus:outline-none focus:text-[#FDC700] group"
                                            aria-haspopup="true"
                                            aria-expanded={openIndex === index}
                                        >
                                            <span className="text-2xl transform transition-transform group-hover:scale-110 group-hover:rotate-3">
                                                {item.icon}
                                            </span>
                                            <span className="text-[11px] font-medium tracking-wide uppercase opacity-80 group-hover:opacity-100">
                                                {item.label}
                                            </span>
                                        </button>
                                        {openIndex === index && (
                                            <ul className="absolute top-full mt-3 bg-slate-800/90 backdrop-blur-md border border-slate-700 rounded-xl shadow-2xl min-w-[200px] z-50 overflow-hidden animate-fadeIn">
                                                {item.dropdown.map((opt, i) => (
                                                    <li key={i}>
                                                        <Link
                                                            to={opt.route}
                                                            onClick={() =>
                                                                setOpenIndex(
                                                                    null,
                                                                )
                                                            }
                                                            className="flex items-center gap-3 px-4 py-2.5 text-sm text-slate-200 hover:bg-[#FDC700] hover:text-slate-900 transition-all duration-150"
                                                        >
                                                            {opt.icon && (
                                                                <span className="text-slate-400 group-hover:text-slate-900">
                                                                    {opt.icon}
                                                                </span>
                                                            )}
                                                            {opt.label}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </>
                                ) : (
                                    <Link
                                        to={item.route}
                                        onClick={() => setOpenIndex(null)}
                                        className="flex flex-col items-center gap-1.5 text-slate-300 hover:text-[#FDC700] transition-all duration-200 group"
                                    >
                                        <span className="text-2xl transform transition-transform group-hover:scale-110 group-hover:rotate-3">
                                            {item.icon}
                                        </span>
                                        <span className="text-[11px] font-medium tracking-wide uppercase opacity-80 group-hover:opacity-100">
                                            {item.label}
                                        </span>
                                    </Link>
                                )}
                            </div>
                        ))}

                        {hiddenItems.length > 0 && (
                            <div className="ml-auto flex flex-col items-center sidebar-toggle">
                                <button
                                    onClick={() => setIsSidebarOpen(true)}
                                    className="text-slate-300 hover:text-[#FDC700] text-3xl p-1 rounded-full focus:outline-none focus:text-[#FDC700] transition-colors"
                                    aria-label="Open menu"
                                >
                                    <FaBars />
                                </button>
                                <span className="text-[11px] font-medium text-slate-400 mt-1 uppercase tracking-wide">
                                    Menu
                                </span>
                            </div>
                        )}

                        {!hideLogout && (
                            <div className="ml-auto flex items-center">
                                <button
                                    onClick={handleLogout}
                                    className="text-slate-300 hover:text-red-400 transition-colors p-1 rounded-full focus:outline-none focus:text-red-400"
                                    aria-label="Logout"
                                >
                                    <RiLogoutCircleRLine size={26} />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </nav>

            {/* Sidebar Overlay */}
            {isSidebarOpen && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 transition-opacity duration-300" />
            )}

            {/* Sidebar */}
            <div
                ref={sidebarRef}
                className={`fixed top-0 right-0 w-80 h-full bg-slate-800 shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
                    isSidebarOpen ? "translate-x-0" : "translate-x-full"
                }`}
            >
                <div className="flex justify-between items-center p-5 border-b border-slate-700">
                    <h2 className="text-xl font-bold text-[#FDC700] tracking-wide">
                        Menu
                    </h2>
                    <button
                        onClick={() => setIsSidebarOpen(false)}
                        className="text-slate-400 hover:text-[#FDC700] text-2xl p-1 rounded-full focus:outline-none focus:text-[#FDC700] transition-colors"
                        aria-label="Close menu"
                    >
                        <FaTimes />
                    </button>
                </div>

                <div className="flex flex-col px-5 py-4 h-[calc(100%-5rem)] overflow-y-auto">
                    {hiddenItems.map((item, idx) => (
                        <div
                            key={idx}
                            className="mb-2 border-b border-slate-700/50 last:border-0"
                        >
                            {item.dropdown ? (
                                <div>
                                    <button
                                        onClick={() =>
                                            setOpenSideIndex(
                                                openSideIndex === idx
                                                    ? null
                                                    : idx,
                                            )
                                        }
                                        className="w-full flex items-center justify-between py-3 px-2 rounded-lg hover:bg-slate-700/50 transition-colors focus:outline-none focus:ring-1 focus:ring-[#FDC700]"
                                        aria-expanded={openSideIndex === idx}
                                    >
                                        <div className="flex items-center gap-3">
                                            <span className="text-slate-300 text-2xl">
                                                {item.icon}
                                            </span>
                                            <span className="font-medium text-slate-200">
                                                {item.label}
                                            </span>
                                        </div>
                                        {openSideIndex === idx ? (
                                            <ChevronUp
                                                size={20}
                                                className="text-[#FDC700]"
                                            />
                                        ) : (
                                            <ChevronDown
                                                size={20}
                                                className="text-slate-500"
                                            />
                                        )}
                                    </button>
                                    <div
                                        className={`overflow-hidden transition-all duration-300 ease-in-out ${
                                            openSideIndex === idx
                                                ? "max-h-96 opacity-100"
                                                : "max-h-0 opacity-0"
                                        }`}
                                    >
                                        <ul className="pl-10 pb-2 space-y-1">
                                            {item.dropdown.map((opt, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to={opt.route}
                                                        onClick={() => {
                                                            setOpenSideIndex(
                                                                null,
                                                            );
                                                            setIsSidebarOpen(
                                                                false,
                                                            );
                                                        }}
                                                        className="flex items-center gap-3 py-2 px-3 text-sm text-slate-400 hover:text-[#FDC700] hover:bg-slate-700/50 rounded-md transition-colors"
                                                    >
                                                        {opt.icon && (
                                                            <span className="w-5">
                                                                {opt.icon}
                                                            </span>
                                                        )}
                                                        {opt.label}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ) : (
                                <Link
                                    to={item.route}
                                    onClick={() => {
                                        setOpenSideIndex(null);
                                        setIsSidebarOpen(false);
                                    }}
                                    className="flex items-center gap-3 py-3 px-2 rounded-lg hover:bg-slate-700/50 transition-colors"
                                >
                                    <span className="text-slate-300 text-2xl">
                                        {item.icon}
                                    </span>
                                    <span className="font-medium text-slate-200">
                                        {item.label}
                                    </span>
                                </Link>
                            )}
                        </div>
                    ))}
                    <button
                        onClick={handleLogout}
                        className="mt-8 py-3 px-4 bg-red-900/30 hover:bg-red-600 text-red-300 hover:text-white rounded-lg flex items-center justify-center gap-2 transition-all focus:outline-none focus:ring-2 focus:ring-red-500"
                    >
                        <RiLogoutCircleRLine size={20} />
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
